export const stripeMixin = {
  computed: {
    card_image() {
      return require('../assets/accepted_cards.png');
    },
  },
}
